module.exports = __webpack_public_path__ + "static/media/recipe_tablet.c8962359.jpg";